import './bookmarkColumnControl.scss';
import React from 'react';
import {BaseCol} from './base-col';
import {useSearchPageType} from '../../../../search-hooks';
import {ColumnControlProps} from '../search-result-item-types';
import {useDispatch} from 'react-redux';
import {ProdDocument} from '../../../../search-types';
import {addBookmark, removeBookmark} from '../../../../../services/search-service';
import {Icons} from '../../../../../icons/icons';
import {SvgIcon} from '../../../../../icons/svgIcon';
import {HibuTooltip} from '../../../../../common/hibuTooltip/hibuTooltip';

export const BookmarkColumnControl = ({doc}: ColumnControlProps): JSX.Element => {
    const searchPageType = useSearchPageType();
    const dispatch = useDispatch();

    const active: boolean = doc.metadata.bookmarked;
    const tooltip = active ? 'search.bookmark.remove' : 'search.bookmark.add';

    const onBookmarkClicked = (e: React.MouseEvent<HTMLElement, MouseEvent>) => {
        e.stopPropagation();
        if (active) {
            dispatch(removeBookmark(searchPageType, doc as ProdDocument));
        } else {
            dispatch(addBookmark(searchPageType, doc as ProdDocument));
        }
    };

    const getBookmarkClassNames = (active: boolean) => {
        if (active) {
            return 'bookmark active';
        }

        return 'bookmark';
    };

    return (
        <BaseCol className={'document-column-bookmark'}>
            <HibuTooltip tooltipKey={tooltip}>
                <SvgIcon className={getBookmarkClassNames(active)} onClick={onBookmarkClicked} icon={Icons.STAR}/>
            </HibuTooltip>
        </BaseCol>
    );
};
